import React, {useContext} from "react"
import Row from "@amzn/meridian/row"
import ButtonGroup, {ButtonOption} from "@amzn/meridian/button-group"
import {FormattedMessage} from "react-intl";
import {PICK_VIEWS} from "./constants/Constants"
import {PickViewSelectorContext} from "./context/PickViewSelectorContext";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {AR_V2, CORE_AMZL} from "../util/Constants";
import Column from "@amzn/meridian/column";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const PickViewSelector = (props) => {
    const {viewState, setViewState} = useContext(PickViewSelectorContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {spacingInset_shorthand2} = useDeviceLayout()

    const toggleView = (newValue) => {
        setViewState(newValue);
    };

    return (
        <div>
            {configViewModel.capability === AR_V2 ?
                (
                    <Column spacingInset={spacingInset_shorthand2} spacing={"none"}>
                        <Row spacingInset="small none small none">
                            <ButtonGroup value={viewState} onChange={toggleView}>
                                <ButtonOption value={PICK_VIEWS.ROUTE_VIEW}>
                                    <FormattedMessage id="PickViewSelector.routeView" defaultMessage={PICK_VIEWS.ROUTE_VIEW} />
                                </ButtonOption>
                                <ButtonOption value={PICK_VIEWS.WORKSTATION_VIEW}>
                                    <FormattedMessage id="PickViewSelector.workstationView" defaultMessage={PICK_VIEWS.WORKSTATION_VIEW} />
                                </ButtonOption>
                            </ButtonGroup>
                        </Row>
                    </Column>
                )
                : null}
            {configViewModel.capability === CORE_AMZL && configViewModel.stationConfig.layoutGridViewEnabled ? (
                    <Column spacingInset={spacingInset_shorthand2} spacing={"none"}>
                        <Row spacingInset="small none small none">
                            <ButtonGroup value={viewState} onChange={toggleView}>
                                <ButtonOption value={PICK_VIEWS.ROUTE_VIEW}>
                                    <FormattedMessage id="PickViewSelector.routeView" defaultMessage={PICK_VIEWS.ROUTE_VIEW} />
                                </ButtonOption>
                                <ButtonOption value={PICK_VIEWS.LAYOUT_GRID_VIEW}>
                                    <FormattedMessage id="PickViewSelector.layoutGridView" defaultMessage={PICK_VIEWS.LAYOUT_GRID_VIEW} />
                                </ButtonOption>
                            </ButtonGroup>
                        </Row>
                    </Column>
                )
                : null}
        </div>
    )
}

export default PickViewSelector




// WEBPACK FOOTER //
// ./src/components/pickStatus/PickViewSelector.js